import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Modal, Button, Form } from '_zari/core'

import { ZrSwal } from 'utils'

import * as AsientosContablesService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const RegistroVentasModal = ({ show, handleClose }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      file: '',
      flagEliminarRegistros: false,
      idPlantilla: '',
      _idSede: ''
    }),
    []
  )

  const parsearYEnviarFormulario = React.useCallback(
    (data, { setSubmitting }) => {
      const submitData = new FormData()
      submitData.append('file', data.file)
      submitData.append('flagEliminarRegistros', data.flagEliminarRegistros)
      submitData.append('idPlantilla', data.idPlantilla)
      submitData.append('_idSede', data._idSede)
      __zariContext.loader.open('Importando Registro Ventas...')
      AsientosContablesService.importarRegistroVentas(submitData)
        .then(() => {
          __zariContext.snack('success', 'Se han importado los registros.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          setSubmitting(false)
          __zariContext.loader.close()
          handleClose()
        })
    },
    [__zariContext, handleClose]
  )

  const submitHandler = React.useCallback(
    async (data, { setSubmitting }) => {
      if (data.flagEliminarRegistros) {
        ZrSwal.showAlert({
          tipo: 'warning',
          mensaje: 'Se eliminarán los asientos del periodo de trabajo actual.',
          showCerrar: true,
          onSuccess: () => {
            parsearYEnviarFormulario(data, { setSubmitting })
          }
        })
      } else {
        parsearYEnviarFormulario(data, { setSubmitting })
      }
    },
    [parsearYEnviarFormulario]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>Importar Registro Ventas</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue, values }) => (
          <Form>
            <Modal.Body>
              <FormGroups.FileFormGroup fIsSubmitting={isSubmitting} setFieldValue={setFieldValue} iError={errors.file} iTouched={touched.file} />
              <FormGroups.PlantillaFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.idPlantilla}
                iTouched={touched.idPlantilla}
              />
              <FormGroups.SedeSelectFormGroup fIsSubmitting={isSubmitting} iError={errors._idSede} iTouched={touched._idSede} />
              <FormGroups.FlagEliminarRegistrosFormGroup fIsSubmitting={isSubmitting} iValue={values.flagEliminarRegistros} />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={handleClose} color='secondary' outline tiny>
                Cerrar
              </Button>
              <Button onClick={handleSubmit} tiny>
                Importar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(RegistroVentasModal)
